/**
 * mutXopRawData.ts
 *
 * 131 verified Mút Xốp quotes and specifications from bao bi.html RAW.
 * Provides fallback quote data and autocomplete options for Xốp tấm, Xốp góc, Xốp L.
 */

export interface MutXopQuoteItem {
  kind: 'Xốp' | 'Xốp tấm' | 'Xốp góc' | 'Xốp L' | string
  spec: string
  uom: string
  density: string
  price: number
  [key: string]: unknown
}

export const MUT_XOP_RAW_ROWS: MutXopQuoteItem[] = [
  {
    "kind": "Xốp tấm",
    "spec": "2000x1000x500",
    "uom": "m³",
    "density": "10kg/m3",
    "price": 587244
  },
  {
    "kind": "Xốp tấm",
    "spec": "2000x1000x500",
    "uom": "m³",
    "density": "12kg/m3",
    "price": 704692
  },
  {
    "kind": "Xốp tấm",
    "spec": "2000x1000x500",
    "uom": "m³",
    "density": "14kg/m3",
    "price": 822141
  },
  {
    "kind": "Xốp tấm",
    "spec": "2000x1000x500",
    "uom": "m³",
    "density": "16kg/m3",
    "price": 939589
  },
  {
    "kind": "Xốp tấm",
    "spec": "2000x1000x500",
    "uom": "m³",
    "density": "8kg/m3",
    "price": 477757
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x20",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 920
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x15",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 745
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x10",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 648
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x20",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 700
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x15",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 557
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x20/50",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 1004
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x20",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 1036
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x15",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 777
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x15",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 702
  },
  {
    "kind": "Xốp góc",
    "spec": "80x80x80x15",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 692
  },
  {
    "kind": "Xốp góc",
    "spec": "80x80x80x25/15",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 940
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x25/15",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 971
  },
  {
    "kind": "Xốp góc",
    "spec": "80x80x50x15",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 761
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x15/30",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 972
  },
  {
    "kind": "Xốp góc",
    "spec": "70x70x70x15/30",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 1124
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x20",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 794
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x25/15",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 918
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x50x15",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 772
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x20",
    "uom": "cái",
    "density": "20kg/m3",
    "price": 1345
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x10",
    "uom": "cái",
    "density": "20kg/m3",
    "price": 778
  },
  {
    "kind": "Xốp góc",
    "spec": "100x80x80x20",
    "uom": "cái",
    "density": "20kg/m3",
    "price": 1350
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x10/25",
    "uom": "cái",
    "density": "20kg/m3",
    "price": 810
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x15/25",
    "uom": "cái",
    "density": "20kg/m3",
    "price": 1002
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x30/15",
    "uom": "cái",
    "density": "20kg/m3",
    "price": 1253
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x15",
    "uom": "cái",
    "density": "20kg/m3",
    "price": 886
  },
  {
    "kind": "Xốp góc",
    "spec": "80x80x80x15",
    "uom": "cái",
    "density": "20kg/m3",
    "price": 772
  },
  {
    "kind": "Xốp góc",
    "spec": "80x80x80x25/15",
    "uom": "cái",
    "density": "20kg/m3",
    "price": 999
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x20",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 1480
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x15",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 1030
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x10",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 839
  },
  {
    "kind": "Xốp góc",
    "spec": "80x80x50x15",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 1253
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x15/30",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 1588
  },
  {
    "kind": "Xốp góc",
    "spec": "90x50x50x10",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 842
  },
  {
    "kind": "Xốp góc",
    "spec": "70x70x70x15/30",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 1588
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x15",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 886
  },
  {
    "kind": "Xốp góc",
    "spec": "60x60x60x11",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 756
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x30/10",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 1337
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x20/10",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 1198
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x25/10",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 1251
  },
  {
    "kind": "Xốp góc",
    "spec": "80x80x50x10",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 1092
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x20",
    "uom": "cái",
    "density": "22kg/m3",
    "price": 961
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x20",
    "uom": "cái",
    "density": "24kg/m3",
    "price": 1615
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x15",
    "uom": "cái",
    "density": "24kg/m3",
    "price": 1076
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x10",
    "uom": "cái",
    "density": "24kg/m3",
    "price": 1037
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x15",
    "uom": "cái",
    "density": "24kg/m3",
    "price": 1058
  },
  {
    "kind": "Xốp góc",
    "spec": "90x90x90x30/10",
    "uom": "cái",
    "density": "24kg/m3",
    "price": 1459
  },
  {
    "kind": "Xốp góc",
    "spec": "100x100x100x30/15",
    "uom": "cái",
    "density": "24kg/m3",
    "price": 1473
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x20",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 3946
  },
  {
    "kind": "Xốp L",
    "spec": "1000x120x100x20",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 4341
  },
  {
    "kind": "Xốp L",
    "spec": "1000x140x140x20",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 5525
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x70x15",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 2960
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x15",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 2960
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x15",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 2959
  },
  {
    "kind": "Xốp L",
    "spec": "1000x60x60x20",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 2367
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x10/30",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 3472
  },
  {
    "kind": "Xốp L",
    "spec": "1000x60x60x30/10",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 3552
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x10",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 1973
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100/100x10/25",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 4341
  },
  {
    "kind": "Xốp L",
    "spec": "460x80x80x20",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 3157
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100/60x25/10",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 3157
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100/100x25/10",
    "uom": "cái",
    "density": "12kg/m3",
    "price": 3946
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x20",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4604
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3453
  },
  {
    "kind": "Xốp L",
    "spec": "1000x70x70x30",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4834
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 2301
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x30/10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4604
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x20",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3683
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100/100x30/20",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 5755
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100/100x30/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 5525
  },
  {
    "kind": "Xốp L",
    "spec": "1000x50/100x30/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4144
  },
  {
    "kind": "Xốp L",
    "spec": "1000x60x60x20",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 2763
  },
  {
    "kind": "Xốp L",
    "spec": "1000x60x60x15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 2071
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x20/10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3914
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 2763
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x25/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 5064
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x25/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4051
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x80x15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3107
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x80x25/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4558
  },
  {
    "kind": "Xốp L",
    "spec": "1000x70x70x15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 2417
  },
  {
    "kind": "Xốp L",
    "spec": "1000x70x70x25/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3545
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x90x15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3107
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x90x25/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4558
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x90x25/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4305
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x90x20",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4144
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x90x10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 2486
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100/70x10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 2348
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x30/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4419
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x60x25/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4051
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x90x30/10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4558
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x90x25/10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3937
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x70x15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 2763
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x60x15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 2590
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x90x30/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4765
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x70x30/15",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4236
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x90x20/10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3833
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x40x30/10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3039
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80/40x10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 1658
  },
  {
    "kind": "Xốp L",
    "spec": "1000x115x40x10/30",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3782
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80/80x25",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 4604
  },
  {
    "kind": "Xốp L",
    "spec": "1000x60x90x25/10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3280
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80/80x10/30",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 3867
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90/90x20/50",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 7251
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90/90x15/40",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 5801
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90/90x55/10",
    "uom": "cái",
    "density": "14kg/m3",
    "price": 7044
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x20",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 5262
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x15",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 3947
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x15",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 3157
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x30/10",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 6314
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x60x15",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 3157
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x15/30",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 6314
  },
  {
    "kind": "Xốp L",
    "spec": "1000x60x60x30/10",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 4566
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x10",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 2631
  },
  {
    "kind": "Xốp L",
    "spec": "1000x50x50x10",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 1315
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90/90x20/50",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 8287
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90/90x15/40",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 6630
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90/90x55/10",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 8050
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x90x15",
    "uom": "cái",
    "density": "16kg/m3",
    "price": 3552
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x15",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 4440
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100/100x10",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 2960
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80/40x10",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 3472
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x20",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 4736
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x15",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 3552
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80x80x10",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 2367
  },
  {
    "kind": "Xốp L",
    "spec": "1000x90x90x15",
    "uom": "cái",
    "density": "18kg/m3",
    "price": 3996
  },
  {
    "kind": "Xốp L",
    "spec": "1000x80/40x10",
    "uom": "cái",
    "density": "20kg/m3",
    "price": 4341
  },
  {
    "kind": "Xốp L",
    "spec": "1000x100x100x10",
    "uom": "cái",
    "density": "24kg/m3",
    "price": 3946
  }
]

export function isRowKind(r: Record<string, any>, kind: string): boolean {
  const normalize = (s: string) =>
    s
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')

  const k = normalize(String(r.kind || r.loai || r.name || r.supplier_item_name || ''))
  const target = normalize(kind)

  if (target === 'xop' || target === 'xop tam') {
    if (k.includes('xop goc') || k.includes('xop l')) {
      return false
    }
    return k === 'xop' || k === 'xop tam' || k.includes('xop tam') || k.startsWith('xop ') || k === 'xop'
  }

  return k === target || k.includes(target)
}

export function getXopGocQcOptions(customRows?: Record<string, any>[]): string[] {
  const isLoaded = Boolean(customRows && customRows.length > 0)
  const rows = isLoaded ? customRows! : MUT_XOP_RAW_ROWS
  return Array.from(
    new Set(
      rows
        .filter((r) => isRowKind(r, 'Xốp góc'))
        .map((r) => String(r.spec ?? r.qc ?? r.kt1 ?? '').trim())
        .filter(Boolean)
    )
  )
}
export const XOP_GOC_QC_OPTIONS = getXopGocQcOptions

export function getXopLMatCatOptions(customRows?: Record<string, any>[]): string[] {
  const isLoaded = Boolean(customRows && customRows.length > 0)
  const rows = isLoaded ? customRows! : MUT_XOP_RAW_ROWS
  const extractMatCat = (r: Record<string, any>): string => {
    if (r.mat_cat) return String(r.mat_cat).trim()
    if (r.kt2) return String(r.kt2).trim()
    const spec = String(r.spec ?? r.qc ?? '').trim()
    const parts = spec.split('x')
    if (parts.length >= 4 || (parts.length === 3 && Number(parts[0]) >= 300)) {
      return parts.slice(1).join('x').trim()
    }
    return parts.length > 1 ? parts.slice(1).join('x').trim() : spec
  }
  return Array.from(
    new Set(
      rows
        .filter((r) => isRowKind(r, 'Xốp L'))
        .map(extractMatCat)
        .filter(Boolean)
    )
  )
}
export const XOP_L_MAT_CAT_OPTIONS = getXopLMatCatOptions

export const XOP_DENSITY_OPTIONS: string[] = [
  '8kg',
  '10kg',
  '12kg',
  '14kg',
  '16kg',
  '18kg',
  '20kg',
  '22kg',
  '24kg',
]

export const XOP_TAM_DENSITY_OPTIONS: string[] = [
  '8kg',
  '10kg',
  '12kg',
  '14kg',
  '16kg',
]

export function sortDensities(list: string[]): string[] {
  return Array.from(new Set(list)).sort((a, b) => {
    const na = parseInt(a, 10) || 0
    const nb = parseInt(b, 10) || 0
    return na - nb
  })
}

export function getDensitiesForXopTam(customRows?: Record<string, any>[]): string[] {
  const isLoaded = Boolean(customRows && customRows.length > 0)
  const rows = isLoaded ? customRows! : MUT_XOP_RAW_ROWS
  const list = rows
    .filter((r) => isRowKind(r, 'Xốp tấm'))
    .map((r) => {
      const clean = String(r.density ?? r.dl ?? r.dinh_luong ?? r.col_1790531641992 ?? '')
        .replace('/m3', '')
        .replace('/m³', '')
        .trim()
      return clean.endsWith('kg') ? clean : `${clean}kg`
    })
    .filter((d) => d !== 'kg')
  const res = sortDensities(list)
  if (isLoaded) {
    return res
  }
  return res.length > 0 ? res : XOP_TAM_DENSITY_OPTIONS
}

export function getDensitiesForXopL(matCat?: string | null, customRows?: Record<string, any>[]): string[] {
  if (!matCat) return []
  const isLoaded = Boolean(customRows && customRows.length > 0)
  const rows = isLoaded ? customRows! : MUT_XOP_RAW_ROWS
  const norm = matCat.trim().toLowerCase().replace(/\s+/g, '').replace(/\*/g, 'x')
  const matched = rows.filter((r) => {
    if (!isRowKind(r, 'Xốp L')) return false
    const spec = String(r.spec ?? r.qc ?? r.kt2 ?? '')
    const parts = spec.split('x')
    const mc = parts.slice(1).join('x').trim().toLowerCase().replace(/\s+/g, '').replace(/\*/g, 'x')
    return mc === norm || spec.toLowerCase().replace(/\s+/g, '').replace(/\*/g, 'x') === norm
  })
  const list = matched
    .map((r) => {
      const clean = String(r.density ?? r.dl ?? r.dinh_luong ?? r.col_1790531641992 ?? '')
        .replace('/m3', '')
        .replace('/m³', '')
        .trim()
      return clean.endsWith('kg') ? clean : `${clean}kg`
    })
    .filter((d) => d !== 'kg')
  return sortDensities(list)
}

export function getDensitiesForXopGoc(qc?: string | null, customRows?: Record<string, any>[]): string[] {
  if (!qc) return []
  const isLoaded = Boolean(customRows && customRows.length > 0)
  const rows = isLoaded ? customRows! : MUT_XOP_RAW_ROWS
  const norm = qc.trim().toLowerCase().replace(/\s+/g, '').replace(/\*/g, 'x')
  const matched = rows.filter((r) => {
    if (!isRowKind(r, 'Xốp góc')) return false
    const s = String(r.spec ?? r.qc ?? r.kt1 ?? '').trim().toLowerCase().replace(/\s+/g, '').replace(/\*/g, 'x')
    return s === norm
  })
  const list = matched
    .map((r) => {
      const clean = String(r.density ?? r.dl ?? r.dinh_luong ?? r.col_1790531641992 ?? '')
        .replace('/m3', '')
        .replace('/m³', '')
        .trim()
      return clean.endsWith('kg') ? clean : `${clean}kg`
    })
    .filter((d) => d !== 'kg')
  return sortDensities(list)
}


